import type { ReactNode } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { AvailabilityProvider } from "@/lib/availability";
import { CartProvider } from "@/lib/cart";
import { CatalogProvider } from "@/lib/catalog-context";

type Props = {
  children: ReactNode;
};

export function AppProviders({ children }: Props) {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <CatalogProvider>
          <AvailabilityProvider>
            <CartProvider>{children}</CartProvider>
          </AvailabilityProvider>
        </CatalogProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
